// utils/validation.ts
import { FormData } from "../types/inscription";

export interface ValidationResult {
  isValid: boolean;
  errors: Record<string, string>; // field -> message
}

export const validateStep = (
  step: number,
  formData: FormData,
  t: any
): ValidationResult => {
  const errors: Record<string, string> = {};

  let requiredMsg = t("inscription.validation.required");

  switch (step) {
    case 0:
      // Terms acceptance step
      if (!formData.termsAccepted) {
        errors.termsAccepted =
          t("inscription.validation.termsRequired") ||
          "Vous devez accepter les conditions d'utilisation";
      }
      break;

    case 1:
      // Personal info step
      if (!formData.fullName.trim()) {
        errors.fullName = t("inscription.validation.requiredFullName");
      }
      if (!formData.gender) {
        errors.gender = t("inscription.validation.requiredGender");
      }
      if (!formData.birthDate) {
        errors.birthDate = t("inscription.validation.requiredBirthdate");
      }
      break;

    case 2:
      // Phone verification step
      if (!formData.phoneNumber.trim()) {
        errors.phoneNumber = requiredMsg;
      } else if (formData.phoneNumber.length < 8) {
        errors.phoneNumber =
          t("inscription.validation.phoneLength", { min: 8 }) ||
          "Le numéro doit contenir au moins 8 chiffres";
      }
      break;

    case 3:
      // OTP verification step
      if (!formData.verificationCode.trim()) {
        errors.verificationCode = requiredMsg;
      } else if (formData.verificationCode.length !== 6) {
        errors.verificationCode =
          t("inscription.validation.codeLength") ||
          "Le code doit contenir 6 chiffres";
      }
      break;

    case 4:
      // Password step
      if (!formData.password) {
        errors.password = requiredMsg;
      } else if (formData.password.length < 4) {
        errors.password =
          t("inscription.validation.minCharacters", { min: 4 }) ||
          "Le mot de passe doit contenir au moins 4 chiffres";
      }

      if (!formData.confirmPassword) {
        errors.confirmPassword = requiredMsg;
      } else if (formData.password !== formData.confirmPassword) {
        errors.confirmPassword =
          t("inscription.validation.passwordMatch") ||
          "Les mots de passe ne correspondent pas";
      }
      break;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const checkAutoProgression = (step: number, data: FormData): boolean => {
  switch (step) {
    case 0:
      // Terms step
      return !!data.termsAccepted;
    case 1:
      // Personal info step
      return !!(data.fullName.trim() && data.gender && data.birthDate);
    case 2:
      // Phone step
      return !!(data.phoneNumber.trim() && data.phoneNumber.length >= 8);
    case 3:
      // OTP step
      return !!(
        data.verificationCode.trim() && data.verificationCode.length === 6
      );
    case 4:
      // Password step
      return !!(
        data.password &&
        data.confirmPassword &&
        data.password === data.confirmPassword &&
        data.password.length >= 4
      );
    default:
      return false;
  }
};

export const getPasswordStrengthColor = (strength: number): string => {
  if (strength <= 25) return "#ff4d4f";
  if (strength <= 50) return "#faad14";
  if (strength <= 75) return "#1890ff";
  return "#52c41a";
};

export const getPasswordStrengthText = (strength: number): string => {
  if (strength <= 25) return "weak";
  if (strength <= 50) return "medium";
  if (strength <= 75) return "strong";
  return "veryStrong";
};
